import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';
import policyListSaga from 'modules/Policy/saga/list';

export default function* policySaga(): SagaIterator {
  yield fork(policyListSaga);
}
